import getLang from 'I18n/utils/getLang';
export const translateService = service => service.additionalLanguages[getLang()] || service.name;
export const getServiceNameById = (id, catalogServices) => {
  const serviceEntry = catalogServices.find(service => service.id === id);
  return serviceEntry ? translateService(serviceEntry) : null;
};